var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScafolding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.89,4.8 27.89,49.18 20,49.18 20,1.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.89,49.68H20c-0.28,0-0.5-0.22-0.5-0.5V1.29c0-0.17,0.09-0.33,0.23-0.42s0.32-0.11,0.48-0.04l7.89,3.51 c0.18,0.08,0.3,0.26,0.3,0.46v44.38C28.38,49.46,28.16,49.68,27.89,49.68z M20.5,48.68h6.89V5.13L20.5,2.06V48.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20,1.29 20,49.18 12.18,49.18 12.18,10.72  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,49.68h-7.82c-0.28,0-0.5-0.22-0.5-0.5V10.72c0-0.12,0.04-0.23,0.12-0.32l7.82-9.43 c0.13-0.16,0.35-0.22,0.55-0.15c0.2,0.07,0.33,0.26,0.33,0.47v47.89C20.5,49.46,20.27,49.68,20,49.68z M12.68,48.68h6.82V2.68 l-6.82,8.23V48.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.43,16.86v32.32H20V9.54C24.14,11.98,28.29,14.42,32.43,16.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.43,49.68H20c-0.28,0-0.5-0.22-0.5-0.5V9.54c0-0.18,0.1-0.34,0.25-0.43c0.16-0.09,0.35-0.09,0.5,0 l12.43,7.33c0.15,0.09,0.25,0.25,0.25,0.43v32.32C32.93,49.46,32.71,49.68,32.43,49.68z M20.5,48.68h11.44V17.15L20.5,10.41 V48.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.43,
    y: 16.86,
    className: "st1",
    width: 8.02,
    height: 32.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.46,49.68h-8.02c-0.28,0-0.5-0.22-0.5-0.5V16.86c0-0.28,0.22-0.5,0.5-0.5h8.02c0.28,0,0.5,0.22,0.5,0.5 v32.32C40.96,49.46,40.73,49.68,40.46,49.68z M32.93,48.68h7.03V17.36h-7.03V48.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.46,16.86h-8.02c-4.14-2.44-8.3-4.89-12.43-7.33h8.02C32.16,11.98,36.32,14.42,40.46,16.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.46,17.36h-8.02c-0.09,0-0.18-0.02-0.25-0.07L19.74,9.97c-0.19-0.11-0.29-0.34-0.23-0.56 S19.77,9.04,20,9.04h8.02c0.09,0,0.18,0.02,0.25,0.07l12.44,7.33C40.9,16.55,41,16.78,40.94,17S40.68,17.36,40.46,17.36z  M32.57,16.37h6.06l-10.74-6.33h-6.06L32.57,16.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.16,
    y: 0.82,
    className: "st0",
    width: 2.19,
    height: 48.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.35,49.68H6.16c-0.28,0-0.5-0.22-0.5-0.5V0.82c0-0.28,0.22-0.5,0.5-0.5h2.19c0.28,0,0.5,0.22,0.5,0.5 v48.37C8.85,49.46,8.62,49.68,8.35,49.68z M6.66,48.68h1.19V1.32H6.66V48.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.05,
    y: 0.82,
    className: "st0",
    width: 2.19,
    height: 48.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.24,49.68h-2.19c-0.28,0-0.5-0.22-0.5-0.5V0.82c0-0.28,0.22-0.5,0.5-0.5h2.19c0.28,0,0.5,0.22,0.5,0.5 v48.37C28.74,49.46,28.51,49.68,28.24,49.68z M26.55,48.68h1.19V1.32h-1.19V48.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.32,
    y: 0.82,
    className: "st0",
    width: 2.19,
    height: 48.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.5,49.68h-2.19c-0.28,0-0.5-0.22-0.5-0.5V0.82c0-0.28,0.22-0.5,0.5-0.5h2.19c0.28,0,0.5,0.22,0.5,0.5 v48.37C47,49.46,46.78,49.68,46.5,49.68z M44.82,48.68H46V1.32h-1.19V48.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.83,
    y: 40.62,
    className: "st0",
    width: 47.67,
    height: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,43.58H1.83c-0.28,0-0.5-0.22-0.5-0.5v-2.45c0-0.28,0.22-0.5,0.5-0.5H49.5c0.28,0,0.5,0.22,0.5,0.5 v2.45C50,43.35,49.78,43.58,49.5,43.58z M2.33,42.58H49v-1.45H2.33V42.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.16,
    y: 25.31,
    className: "st0",
    width: 47.67,
    height: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.84,28.26H1.16c-0.28,0-0.5-0.22-0.5-0.5v-2.45c0-0.28,0.22-0.5,0.5-0.5h47.67c0.28,0,0.5,0.22,0.5,0.5 v2.45C49.34,28.04,49.11,28.26,48.84,28.26z M1.66,27.26h46.68v-1.45H1.66V27.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.26,40.28 10.26,43.42 8.6,43.42 8.6,44.32 5.94,44.32 5.94,39.37 8.6,39.37 8.6,40.28  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,44.82H5.94c-0.28,0-0.5-0.22-0.5-0.5v-4.95c0-0.28,0.22-0.5,0.5-0.5H8.6c0.28,0,0.5,0.22,0.5,0.5v0.4 h1.16c0.28,0,0.5,0.22,0.5,0.5v3.15c0,0.28-0.22,0.5-0.5,0.5H9.1v0.4C9.1,44.6,8.88,44.82,8.6,44.82z M6.44,43.83H8.1v-0.4 c0-0.28,0.22-0.5,0.5-0.5h1.16v-2.15H8.6c-0.28,0-0.5-0.22-0.5-0.5v-0.4H6.44V43.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.14,40.28 24.14,43.42 25.8,43.42 25.8,44.32 28.46,44.32 28.46,39.37 25.8,39.37 25.8,40.28  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.46,44.82H25.8c-0.28,0-0.5-0.22-0.5-0.5v-0.4h-1.16c-0.28,0-0.5-0.22-0.5-0.5v-3.15 c0-0.28,0.22-0.5,0.5-0.5h1.16v-0.4c0-0.28,0.22-0.5,0.5-0.5h2.66c0.28,0,0.5,0.22,0.5,0.5v4.95 C28.96,44.6,28.74,44.82,28.46,44.82z M26.3,43.83h1.66v-3.95H26.3v0.4c0,0.28-0.22,0.5-0.5,0.5h-1.16v2.15h1.16 c0.28,0,0.5,0.22,0.5,0.5V43.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.41,40.28 42.41,43.42 44.07,43.42 44.07,44.32 46.73,44.32 46.73,39.37 44.07,39.37  44.07,40.28  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.73,44.82h-2.66c-0.28,0-0.5-0.22-0.5-0.5v-0.4h-1.16c-0.28,0-0.5-0.22-0.5-0.5v-3.15 c0-0.28,0.22-0.5,0.5-0.5h1.16v-0.4c0-0.28,0.22-0.5,0.5-0.5h2.66c0.28,0,0.5,0.22,0.5,0.5v4.95 C47.23,44.6,47.01,44.82,46.73,44.82z M44.57,43.83h1.66v-3.95h-1.66v0.4c0,0.28-0.22,0.5-0.5,0.5h-1.16v2.15h1.16 c0.28,0,0.5,0.22,0.5,0.5V43.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.26,24.96 10.26,28.11 8.6,28.11 8.6,29.01 5.94,29.01 5.94,24.06 8.6,24.06 8.6,24.96  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,29.51H5.94c-0.28,0-0.5-0.22-0.5-0.5v-4.95c0-0.28,0.22-0.5,0.5-0.5H8.6c0.28,0,0.5,0.22,0.5,0.5v0.4 h1.16c0.28,0,0.5,0.22,0.5,0.5v3.15c0,0.28-0.22,0.5-0.5,0.5H9.1v0.4C9.1,29.29,8.88,29.51,8.6,29.51z M6.44,28.51H8.1v-0.4 c0-0.28,0.22-0.5,0.5-0.5h1.16v-2.15H8.6c-0.28,0-0.5-0.22-0.5-0.5v-0.4H6.44V28.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.14,24.96 24.14,28.11 25.8,28.11 25.8,29.01 28.46,29.01 28.46,24.06 25.8,24.06 25.8,24.96  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.46,29.51H25.8c-0.28,0-0.5-0.22-0.5-0.5v-0.4h-1.16c-0.28,0-0.5-0.22-0.5-0.5v-3.15 c0-0.28,0.22-0.5,0.5-0.5h1.16v-0.4c0-0.28,0.22-0.5,0.5-0.5h2.66c0.28,0,0.5,0.22,0.5,0.5v4.95 C28.96,29.29,28.74,29.51,28.46,29.51z M26.3,28.51h1.66v-3.95H26.3v0.4c0,0.28-0.22,0.5-0.5,0.5h-1.16v2.15h1.16 c0.28,0,0.5,0.22,0.5,0.5V28.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.41,24.96 42.41,28.11 44.07,28.11 44.07,29.01 46.73,29.01 46.73,24.06 44.07,24.06  44.07,24.96  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.73,29.51h-2.66c-0.28,0-0.5-0.22-0.5-0.5v-0.4h-1.16c-0.28,0-0.5-0.22-0.5-0.5v-3.15 c0-0.28,0.22-0.5,0.5-0.5h1.16v-0.4c0-0.28,0.22-0.5,0.5-0.5h2.66c0.28,0,0.5,0.22,0.5,0.5v4.95 C47.23,29.29,47.01,29.51,46.73,29.51z M44.57,28.51h1.66v-3.95h-1.66v0.4c0,0.28-0.22,0.5-0.5,0.5h-1.16v2.15h1.16 c0.28,0,0.5,0.22,0.5,0.5V28.51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10,
    className: "st0",
    width: 47.67,
    height: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.17,12.95H0.5c-0.28,0-0.5-0.22-0.5-0.5V10c0-0.28,0.22-0.5,0.5-0.5h47.67c0.28,0,0.5,0.22,0.5,0.5v2.45 C48.67,12.73,48.45,12.95,48.17,12.95z M1,11.95h46.68V10.5H1V11.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.26,9.65 10.26,12.8 8.6,12.8 8.6,13.7 5.94,13.7 5.94,8.75 8.6,8.75 8.6,9.65  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,14.2H5.94c-0.28,0-0.5-0.22-0.5-0.5V8.75c0-0.28,0.22-0.5,0.5-0.5H8.6c0.28,0,0.5,0.22,0.5,0.5v0.4 h1.16c0.28,0,0.5,0.22,0.5,0.5v3.15c0,0.28-0.22,0.5-0.5,0.5H9.1v0.4C9.1,13.97,8.88,14.2,8.6,14.2z M6.44,13.2H8.1v-0.4 c0-0.28,0.22-0.5,0.5-0.5h1.16v-2.15H8.6c-0.28,0-0.5-0.22-0.5-0.5v-0.4H6.44V13.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.14,9.65 24.14,12.8 25.8,12.8 25.8,13.7 28.46,13.7 28.46,8.75 25.8,8.75 25.8,9.65  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.46,14.2H25.8c-0.28,0-0.5-0.22-0.5-0.5v-0.4h-1.16c-0.28,0-0.5-0.22-0.5-0.5V9.65 c0-0.28,0.22-0.5,0.5-0.5h1.16v-0.4c0-0.28,0.22-0.5,0.5-0.5h2.66c0.28,0,0.5,0.22,0.5,0.5v4.95 C28.96,13.97,28.74,14.2,28.46,14.2z M26.3,13.2h1.66V9.25H26.3v0.4c0,0.28-0.22,0.5-0.5,0.5h-1.16v2.15h1.16 c0.28,0,0.5,0.22,0.5,0.5V13.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.41,9.65 42.41,12.8 44.07,12.8 44.07,13.7 46.73,13.7 46.73,8.75 44.07,8.75 44.07,9.65  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.73,14.2h-2.66c-0.28,0-0.5-0.22-0.5-0.5v-0.4h-1.16c-0.28,0-0.5-0.22-0.5-0.5V9.65 c0-0.28,0.22-0.5,0.5-0.5h1.16v-0.4c0-0.28,0.22-0.5,0.5-0.5h2.66c0.28,0,0.5,0.22,0.5,0.5v4.95 C47.23,13.97,47.01,14.2,46.73,14.2z M44.57,13.2h1.66V9.25h-1.66v0.4c0,0.28-0.22,0.5-0.5,0.5h-1.16v2.15h1.16 c0.28,0,0.5,0.22,0.5,0.5V13.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScafolding);
export default __webpack_public_path__ + "static/media/scafolding.dff288779dfd04149b0661b8cb0012e0.svg";
export { ForwardRef as ReactComponent };